import { styles } from './template.scss';
import { styles as commonStyles } from '../../../../assets/common.scss';

export const templateCompanyAuthenticationForm = document.createElement('template');

templateCompanyAuthenticationForm.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <div class='form-wrapper'>
    <gz-title fontSize='11' fontWeight='600' class='subsection-title' id='twoFactorAuthTitle'></gz-title>

    <div class='myCompany-authentication-section'>
      <div class='myCompany-authentication-subsection'>
        <gz-form-field id='twoFactorAuthCheckbox' class='myCompany-authentication-checkbox' disabled>
          <gz-checkbox gz-form-input id='twoFactorAuthCheckboxInput' label='' checked></gz-checkbox>
        </gz-form-field>
        <gz-text id="twoFactorAuthCheckboxInfoText" fontSize="12" fontWeight="400" class="helper-text" />
      </div>
      <div class='myCompany-authentication-subsection'>
        <gz-form-field id='skipTwoFactorAuthFormField' class='label-mw-250' label='' required>
          <gz-dropdown gz-form-input type='dropdown' labelWidth="240"></gz-dropdown>
          <gz-input-error></gz-input-error>
        </gz-form-field>
        <gz-text id="skipTwoFactorAuthInfoText" fontSize="10" fontWeight="400"  />
      </div>
    </div>

    <gz-title fontSize='11' fontWeight='600' class='subsection-title' id='passwordExpiryOptionsTitle'></gz-title>

    <div class='myCompany-authentication-section'>
      <div class='myCompany-authentication-subsection'>
        <gz-form-field id='passwordAgeCheckbox' class='myCompany-authentication-checkbox'>
          <gz-checkbox gz-form-input id='passwordAgeCheckboxInput' label=''></gz-checkbox>
        </gz-form-field>
        <gz-text id="passwordAgeCheckboxInfoText" fontSize="12" fontWeight="400" class="helper-text" />
      </div>
      <div class='myCompany-authentication-subsection'>
        <gz-form-field id='lockAccountCheckbox' class='myCompany-authentication-checkbox'>
          <gz-checkbox gz-form-input id='lockAccountCheckboxInput' label=''></gz-checkbox>
        </gz-form-field>
        <gz-text id="lockAccountCheckboxInfoText" fontSize="12" fontWeight="400" class="helper-text" />
      </div>
    </div>

    <gz-title fontSize='11' fontWeight='600' class='subsection-title' id='ssoSamlTitle'></gz-title>

    <div class='myCompany-authentication-section'>
      <div class='myCompany-authentication-section-title'>
          <div class="myCompany-authentication-ssoSamlKb-container">
            <gz-text fontSize='14' fontWeight='400' class='myCompany-authentication-section-text' id='ssoSamlKbLink'></gz-text>
            <gz-link id='gravityZoneSamlKbUrl' type='underline' color='primary'></gz-link>
          </div>
          <gz-copy-to-clipboard id='copyToClipboardGzMetadataUrl'>
        <gz-form-field id='gravityZoneMetadataUrl' label='' class='label-mw-250' readonly>
          <gz-input gz-form-input class='input-content' inputwidth='240'></gz-input>
        </gz-form-field>
      </gz-copy-to-clipboard>

      <gz-form-field id='ssoSamlIdentityProviderMetadata' label='' class='label-text label-mw-250'>
        <gz-input gz-form-input class='input-content' placeholder='' inputwidth='240'></gz-input>
        <gz-input-error></gz-input-error>
      </gz-form-field>
    </div>
  </div>
`;
